<main class="menu-page"   [style.--primary-color]="restaurant?.primaryColor || '#ff6b00'"
  [style.--secondary-color]="restaurant?.secondaryColor || '#171717'">

  <!-- ESTADOS -->
  <section *ngIf="loading" class="page-state">
    <div class="loading-spinner"></div>
    <strong>Carregando cardápio</strong>
    <span>Estamos preparando tudo para você.</span>
  </section>

  <section *ngIf="!loading && error" class="page-state page-state-error">
    <div class="state-icon">!</div>
    <strong>Não foi possível carregar</strong>
    <span>{{ error }}</span>
  </section>

  <ng-container *ngIf="restaurant">

   <!-- =====================================================
     NOVO TOPO DO CARDÁPIO
     ===================================================== -->

<header class="food-app-header" [style.--restaurant-cover]="
    restaurant.coverUrl
      ? 'url(' + restaurant.coverUrl + ')'
      : 'none'
  ">

  <div class="food-app-header-inner">

    <!-- LINHA SUPERIOR -->
    <div class="food-topbar">

      <!-- RESTAURANTE -->
      <div class="food-brand">

        <div class="food-brand-logo">
          <img
            *ngIf="restaurant.logoUrl"
            [src]="getImageUrl(restaurant.logoUrl)"
            [alt]="restaurant.name">

          <span *ngIf="!restaurant.logoUrl">
            {{ restaurant.name?.charAt(0) }}
          </span>
        </div>

        <div class="food-brand-info">

          <strong>
            {{ restaurant.name }}
          </strong>

          <!-- <span
            class="food-open-status"
            [class.closed]="!restaurant.isOpen">

            <span class="food-status-dot"></span>

            {{
              restaurant.isOpen
                ? 'Aberto agora'
                : 'Fechado'
            }}

          </span> -->



          <span
  class="food-open-status"
  [class.closed]="!restaurantIsOpen"
>

  <span
    class="food-status-dot"
  ></span>

  {{
    getOpeningStatusText()
  }}

</span>


<p
  class="food-brand-description"
  *ngIf="restaurant.description"
>
  {{ restaurant.description }}
</p>


        </div>

      </div>


      <!-- AÇÕES -->
      <div class="food-header-actions">

        <!-- NÃO LOGADO -->
        <ng-container *ngIf="!customerLogged">

          <button
            type="button"
            class="food-login-button"
            (click)="goToCustomerLogin()">

            Entrar

          </button>

          <button
            type="button"
            class="food-register-button"
            (click)="goToCustomerRegister()">

            Criar conta

          </button>

        </ng-container>


        <!-- LOGADO -->
        <ng-container *ngIf="customerLogged">

          <button
            type="button"
            class="food-orders-button"
            (click)="goToMyOrders()"
            title="Meus pedidos">

            <span class="food-action-icon">
              🧾
            </span>

            <span class="food-orders-label">
              Meus pedidos
            </span>

          </button>


          <div
            class="food-customer-avatar"
            [title]="customerLogged.name">

            {{
              customerLogged.name?.charAt(0)
            }}

          </div>


          <button
            type="button"
            class="food-logout-button"
            aria-label="Sair"
            title="Sair"
            (click)="logoutCustomer()">

            ↗

          </button>

        </ng-container>

      </div>

    </div>


    <!-- CONTEÚDO PRINCIPAL -->
    <div class="food-header-content">

      <!-- ENTREGA -->
      <button
        type="button"
        class="food-location-card">

        <span class="food-location-icon">
          📍
        </span>

        <span class="food-location-text">

          <small>
            Pedir em
          </small>

          <strong>
            Delivery, retirada ou mesa
          </strong>

        </span>

        <span class="food-location-arrow">
          ›
        </span>

      </button>


      <!-- BUSCA -->
      <div class="food-search">

        <span class="food-search-icon">
          🔎
        </span>

        <input
          type="search"
          [(ngModel)]="searchText"
          placeholder="O que você quer pedir hoje?"
          autocomplete="off">

        <button
          *ngIf="searchText"
          type="button"
          class="food-search-clear"
          aria-label="Limpar pesquisa"
          title="Limpar pesquisa"
          (click)="searchText = ''">
          ×
        </button>

        <button
          type="button"
          class="food-filter-button"
          [class.active]="hasActiveFilters"
          aria-label="Filtros"
          title="Filtrar cardápio"
          (click)="toggleFilters()">

          ☰

          <span
            class="filter-indicator"
            *ngIf="hasActiveFilters">
          </span>

        </button>

      </div>

    </div>


    <!-- MODOS DE PEDIDO -->
    <div class="food-order-types">

      <button
        type="button"
        class="food-order-type"
        [class.active]="customer.deliveryType === 'DELIVERY'"
        (click)="selectDeliveryType('DELIVERY')">

        <span>🛵</span>

        <div>
          <small>Receber em casa</small>
          <strong>Delivery</strong>
        </div>

      </button>


      <button
        type="button"
        class="food-order-type"
        [class.active]="customer.deliveryType === 'PICKUP'"
        (click)="selectDeliveryType('PICKUP')">

        <span>🥡</span>

        <div>
          <small>Buscar no local</small>
          <strong>Retirada</strong>
        </div>

      </button>


      <button
        type="button"
        class="food-order-type"
        [class.active]="customer.deliveryType === 'TABLE'"
        (click)="selectDeliveryType('TABLE')">

        <span>🍽️</span>

        <div>
          <small>Consumir no local</small>
          <strong>Mesa</strong>
        </div>

      </button>

    </div>

    <!-- =====================================================
         CALCULADORA DE ENTREGA
         ===================================================== -->

   <!-- =====================================================
     TAXA / CALCULADORA DE ENTREGA
     ===================================================== -->

<section
  class="delivery-calculator"
  [class.delivery-calculator-fixed]="
    restaurant.deliveryFeeType === 'FIXED'
  "
  *ngIf="customer.deliveryType === 'DELIVERY'"
>

  <div class="delivery-calculator-icon">
    📍
  </div>


  <div class="delivery-calculator-content">

    <!-- ==========================================
         CABEÇALHO - TAXA POR CEP
         ========================================== -->

    <div
      class="delivery-calculator-title"
      *ngIf="restaurant.deliveryFeeType === 'ZIP_CODE'"
    >
      <strong>
        Calcule a taxa de entrega
      </strong>

      <small>
        Informe seu CEP para consultar
        o valor da entrega.
      </small>
    </div>


    <!-- ==========================================
         CABEÇALHO - TAXA FIXA
         ========================================== -->

    <div
      class="delivery-fixed-header"
      *ngIf="restaurant.deliveryFeeType === 'FIXED'"
    >

      <div>
        <strong>
          Taxa de entrega
        </strong>

        <small>
          Valor da entrega para este restaurante.
        </small>
      </div>


      <strong class="delivery-fixed-price">
        {{
          restaurant.deliveryFee > 0
            ? formatMoney(restaurant.deliveryFee)
            : 'Grátis'
        }}
      </strong>

    </div>


    <!-- ==========================================
         TAXA POR CEP
         ========================================== -->

    <div
      class="delivery-cep-row"
      *ngIf="restaurant.deliveryFeeType === 'ZIP_CODE'"
    >

      <div class="delivery-cep-input">

        <span>📍</span>

        <input
          type="text"
          inputmode="numeric"
          maxlength="9"
          [(ngModel)]="customer.customerZipCode"
          (input)="onZipCodeInput()"
          (keyup.enter)="calculateDeliveryFee()"
          placeholder="Digite seu CEP"
          autocomplete="postal-code"
        >

      </div>


      <button
        type="button"
        class="delivery-calculate-button"
        [disabled]="
          deliveryFeeLoading ||
          normalizeZipCode(
            customer.customerZipCode
          ).length !== 8
        "
        (click)="calculateDeliveryFee()"
      >

        {{
          deliveryFeeLoading
            ? 'Consultando...'
            : 'Calcular'
        }}

      </button>

    </div>


    <!-- ==========================================
         RESULTADO POSITIVO DO CEP
         ========================================== -->

    <div
      class="delivery-result success"
      *ngIf="
        restaurant.deliveryFeeType === 'ZIP_CODE' &&
        deliveryFeeCalculated &&
        deliveryAvailable === true
      "
    >

      <span class="delivery-result-check">
        ✓
      </span>


      <div>

        <small>
          Entregamos no seu CEP
        </small>

        <strong
          *ngIf="deliveryRegionName"
        >
          {{ deliveryRegionName }}
        </strong>

      </div>


      <b>
        {{
          calculatedDeliveryFee > 0
            ? formatMoney(
                calculatedDeliveryFee
              )
            : 'Grátis'
        }}
      </b>

    </div>


    <!-- ==========================================
         CEP SEM COBERTURA / ERRO
         ========================================== -->

    <div
      class="delivery-result error"
      *ngIf="
        restaurant.deliveryFeeType === 'ZIP_CODE' &&
        deliveryFeeError
      "
    >

      <span>
        !
      </span>


      <div>

        <strong>
          Não foi possível calcular
        </strong>

        <small>
          {{ deliveryFeeError }}
        </small>

      </div>

    </div>

  </div>

</section>

  </div>

</header>

    <!-- =====================================================
         FILTROS DO CARDÁPIO
         ===================================================== -->

    <div
      class="filters-backdrop"
      *ngIf="filtersOpen"
      (click)="closeFilters()">
    </div>

    <aside
      class="menu-filters-panel"
      *ngIf="filtersOpen">

      <header class="filters-panel-header">

        <div>
          <span>PERSONALIZE SUA BUSCA</span>
          <h2>Filtrar cardápio</h2>
        </div>

        <button
          type="button"
          class="filters-close"
          aria-label="Fechar filtros"
          (click)="closeFilters()">
          ×
        </button>

      </header>


      <section class="filter-section">

        <h3>Categoria</h3>

        <div class="category-filter-list">

          <button
            type="button"
            [class.active]="selectedCategoryId === null"
            (click)="selectCategoryFilter(null)">
            Todas
          </button>

          <button
            type="button"
            *ngFor="let category of restaurant?.categories"
            [class.active]="selectedCategoryId === category.id"
            (click)="selectCategoryFilter(category.id)">
            {{ category.name }}
          </button>

        </div>

      </section>


      <section class="filter-section">

        <h3>Ordenar produtos</h3>

        <label class="filter-radio">
          <input
            type="radio"
            name="priceOrder"
            value="DEFAULT"
            [(ngModel)]="priceOrder">
          <span>Relevância</span>
        </label>

        <label class="filter-radio">
          <input
            type="radio"
            name="priceOrder"
            value="LOWEST"
            [(ngModel)]="priceOrder">
          <span>Menor preço</span>
        </label>

        <label class="filter-radio">
          <input
            type="radio"
            name="priceOrder"
            value="HIGHEST"
            [(ngModel)]="priceOrder">
          <span>Maior preço</span>
        </label>

      </section>


      <section class="filter-section">

        <label class="availability-filter">

          <div>
            <strong>Somente disponíveis</strong>
            <span>Ocultar produtos indisponíveis</span>
          </div>

          <input
            type="checkbox"
            [(ngModel)]="onlyAvailable">

        </label>

      </section>


      <footer class="filters-panel-footer">

        <button
          type="button"
          class="clear-filters-button"
          (click)="clearFilters()">
          Limpar
        </button>

        <button
          type="button"
          class="apply-filters-button"
          (click)="closeFilters()">
          Ver resultados
        </button>

      </footer>

    </aside>

    <!-- =====================================================
         DESTAQUE DO RESTAURANTE
         ===================================================== -->

    <!-- <section class="restaurant-highlight">

      <div class="restaurant-highlight-copy">

        <span class="restaurant-highlight-kicker">
          🍴 BEM-VINDO AO NOSSO CARDÁPIO
        </span>

        <h2>
          Escolha seus favoritos
          <span>e peça do seu jeito.</span>
        </h2>

        <p>
          Explore o cardápio, encontre seus pratos preferidos
          e escolha entre delivery, retirada ou consumo no local.
        </p>

        <div class="restaurant-highlight-badges">
          <span>⚡ Pedido rápido</span>
          <span>🛵 Delivery</span>
          <span>🥡 Retirada</span>
          <span>🍽️ Mesa</span>
        </div>

      </div>

      <div class="restaurant-highlight-brand">

        <div class="restaurant-highlight-glow"></div>

        <div class="restaurant-highlight-logo">
          <img
            *ngIf="restaurant.logoUrl"
            [src]="getImageUrl(restaurant.logoUrl)"
            [alt]="restaurant.name">

          <span *ngIf="!restaurant.logoUrl">
            {{ restaurant.name?.charAt(0) }}
          </span>
        </div>

        <div class="restaurant-highlight-name">
          <small>Você está em</small>
          <strong>{{ restaurant.name }}</strong>

          <span
            class="restaurant-highlight-status"
            [class.closed]="!restaurant.isOpen">
            <i></i>
            {{
              restaurant.isOpen
                ? 'Aberto agora'
                : 'Fechado'
            }}
          </span>
        </div>

      </div>

    </section> -->


    <!-- PEDIDO EM ANDAMENTO -->
    <section
      class="active-order-card"
      *ngIf="activeOrder"
      (click)="goToActiveOrder()">

      <div class="active-order-icon">🛵</div>

      <div class="active-order-content">
        <small>PEDIDO EM ANDAMENTO</small>
        <strong>{{ getActiveOrderStatusLabel() }}</strong>
        <span>Toque para acompanhar seu pedido.</span>
      </div>

      <button type="button" aria-label="Acompanhar pedido">→</button>
    </section>

    <!-- CATEGORIAS -->
    <section class="categories-section">
      <!-- <div class="section-heading">
        <div>
          <span class="section-kicker">EXPLORE</span>
          <h2>Categorias</h2>
        </div>

        <span class="section-count">
          {{ restaurant.categories?.length || 0 }} opções
        </span>
      </div> -->

      <!-- <nav class="category-tabs">
        <a
          *ngFor="let category of restaurant.categories"
          [href]="'#cat-' + category.id">
          <span class="category-dot"></span>
          {{ category.name }}
        </a>
      </nav> -->


<nav class="category-showcase">
  <!-- <a
    class="category-card"
    *ngFor="let category of restaurant.categories"
    [href]="'#cat-' + category.id">

    <div class="category-image">
      <img
        *ngIf="category.imageUrl"
        [src]="getImageUrl(category.imageUrl)"
        [alt]="category.name">

      <div
        *ngIf="!category.imageUrl"
        class="category-placeholder">
        {{ category.name?.charAt(0) }}
      </div>
    </div>

    <span class="category-name">
      {{ category.name }}
    </span>
  </a> -->

 <button
    type="button"
    class="category-card"
    *ngFor="let category of restaurant.categories"
    (click)="scrollToCategory(category.id)">

    <div class="category-image">

      <img
        *ngIf="category.imageUrl"
        [src]="getImageUrl(category.imageUrl)"
        [alt]="category.name">

      <div
        *ngIf="!category.imageUrl"
        class="category-placeholder">
        {{ category.name?.charAt(0) }}
      </div>

    </div>

    <span class="category-name">
      {{ category.name }}
    </span>

  </button>

</nav>



    </section>

    <!-- CARDÁPIO -->
    <section class="menu-content">

      <header class="menu-title-block">
        <div>
          <span class="section-kicker">NOSSO CARDÁPIO</span>
          <h2>Escolha o que deseja pedir</h2>
          <p>Toque em um item para ver detalhes e adicionar à sacola.</p>
        </div>
      </header>

      <ng-container
        *ngFor="let category of restaurant.categories">

        <section
          class="menu-category"
          *ngIf="categoryHasVisibleProducts(category)"
          [id]="'cat-' + category.id">

          <header class="category-header">
            <div>
              <h2>{{ category.name }}</h2>
              <p *ngIf="category.description">
                {{ category.description }}
              </p>
            </div>

            <span class="category-count">
              {{ filteredCategoryProducts(category).length }}
              itens
            </span>
          </header>

          <div class="products-grid">

            <article
              class="product-card"
              *ngFor="let product of filteredCategoryProducts(category)"
              [class.product-card-disabled]="product.isActive === false"
              tabindex="0"
              (click)="openProduct(product)"
              (keyup.enter)="openProduct(product)">

            <div class="product-image">
              <img
                *ngIf="product.imageUrl"
                [src]="getImageUrl(product.imageUrl)"
                [alt]="product.name">

              <div
                *ngIf="!product.imageUrl"
                class="product-placeholder">
                {{ product.name?.charAt(0) }}
              </div>

              <span
                class="product-unavailable"
                *ngIf="product.isActive === false">
                Indisponível
              </span>

              <button
                type="button"
                class="favorite-button"
                tabindex="-1"
                aria-label="Favoritar">
                ♡
              </button>
            </div>

            <div class="product-content">

              <div class="product-text">
                <h3>{{ product.name }}</h3>

                <p *ngIf="product.description">
                  {{ product.description }}
                </p>
              </div>

              <div class="product-footer">
                <strong class="product-price">
                  {{ formatMoney(product.price) }}
                </strong>

                <button
                  type="button"
                  class="add-product-button"
                  [disabled]="product.isActive === false"
                  aria-label="Adicionar produto"
                  (click)="openProduct(product); $event.stopPropagation()">
                  +
                </button>
              </div>

            </div>
          </article>

        </div>
      </section>

      </ng-container>

    </section>

    <!-- SACOLA FLUTUANTE -->
    <button
      type="button"
      class="floating-cart"
      *ngIf="cartItems.length > 0"
      (click)="cartOpen = true">

      <span class="floating-cart-left">
        <span class="floating-cart-icon">
          🛍️
          <span class="cart-counter">
            {{ cartItems.length }}
          </span>
        </span>

        <span class="floating-cart-text">
          <small>Seu pedido</small>
          <strong>Ver sacola</strong>
        </span>
      </span>

      <strong class="floating-cart-total">
        {{ formatMoney(total()) }}
      </strong>
    </button>

    <!-- MODAL PRODUTO -->
    <aside
      class="product-modal"
      *ngIf="productModalOpen && selectedProduct">

      <div class="product-modal-panel">

        <button
          type="button"
          class="modal-close"
          (click)="closeProductModal()">
          ×
        </button>

        <div class="modal-product-image">
          <img
            *ngIf="selectedProduct.imageUrl"
            [src]="getImageUrl(selectedProduct.imageUrl)"
            [alt]="selectedProduct.name">

          <div
            *ngIf="!selectedProduct.imageUrl"
            class="modal-no-image">
            {{ selectedProduct.name?.charAt(0) }}
          </div>
        </div>

        <div class="modal-product-body">
          <span class="section-kicker">DETALHES DO ITEM</span>
          <h2>{{ selectedProduct.name }}</h2>

          <p *ngIf="selectedProduct.description">
            {{ selectedProduct.description }}
          </p>

          <strong class="modal-product-price">
            {{ formatMoney(selectedProduct.price) }}
          </strong>

          <div class="product-observation">
            <label for="productObservation">
              Alguma observação?
            </label>

            <textarea
              id="productObservation"
              [(ngModel)]="productObservation"
              rows="3"
              maxlength="250"
              placeholder="Ex: sem cebola, carne bem passada...">
            </textarea>

            <small>Até 250 caracteres.</small>
          </div>
        </div>

        <div class="modal-product-footer">

          <div class="modal-qty">
            <button
              type="button"
              (click)="decreaseProductQuantity()">
              −
            </button>

            <span>{{ productQuantity }}</span>

            <button
              type="button"
              (click)="increaseProductQuantity()">
              +
            </button>
          </div>

          <button
            type="button"
            class="modal-add-button"
            [disabled]="productQuantity <= 0"
            (click)="addSelectedProduct()">

            <span>Adicionar</span>

            <strong>
              {{ formatMoney(selectedProduct.price * productQuantity) }}
            </strong>
          </button>

        </div>
      </div>
    </aside>

    <!-- CARRINHO -->
    <aside
      class="cart"
      *ngIf="cartOpen">

      <div class="cart-panel">

        <div class="cart-header">
          <button
            type="button"
            class="cart-back"
            (click)="cartOpen = false">
            ←
          </button>

          <div>
            <small>SEU PEDIDO</small>
            <h3>Sacola</h3>
          </div>

          <button
            type="button"
            class="cart-clear"
            (click)="cart.clear()">
            Limpar
          </button>
        </div>

        <div class="cart-restaurant">
          <div class="cart-restaurant-logo">
            <img
              *ngIf="restaurant.logoUrl"
              [src]="getImageUrl(restaurant.logoUrl)"
              [alt]="restaurant.name">

            <span *ngIf="!restaurant.logoUrl">
              {{ restaurant.name?.charAt(0) }}
            </span>
          </div>

          <div>
            <small>Pedido em</small>
            <strong>{{ restaurant.name }}</strong>

            <button
              type="button"
              class="add-more"
              (click)="cartOpen = false">
              + Adicionar mais itens
            </button>
          </div>
        </div>

        <div class="cart-items">
          <h4>Itens adicionados</h4>

          <article
            class="cart-item"
            *ngFor="let item of cartItems">

            <div class="cart-item-photo">
              <img
                *ngIf="item.product.imageUrl"
                [src]="getImageUrl(item.product.imageUrl)"
                [alt]="item.product.name">

              <span *ngIf="!item.product.imageUrl">
                {{ item.product.name?.charAt(0) }}
              </span>
            </div>

            <div class="cart-item-main">
              <strong>{{ item.product.name }}</strong>

              <p *ngIf="item.product.description">
                {{ item.product.description }}
              </p>

              <p class="item-note" *ngIf="item.notes">
                📝 {{ item.notes }}
              </p>

              <strong class="cart-item-price">
                {{ formatMoney(item.product.price * item.quantity) }}
              </strong>
            </div>

            <div class="cart-qty-box">
              <button
                type="button"
                (click)="cart.changeQuantity(item.product.id, item.quantity - 1, item.notes)">
                −
              </button>

              <span>{{ item.quantity }}</span>

              <button
                type="button"
                (click)="cart.changeQuantity(item.product.id, item.quantity + 1, item.notes)">
                +
              </button>
            </div>
          </article>
        </div>




<!-- CUPOM -->

<section class="cart-coupon">

  <div class="cart-coupon-header">

    <div>
      <span class="coupon-icon">
        🎟️
      </span>

      <div>
        <strong>
          Cupom de desconto
        </strong>

        <small>
          Tem um código promocional?
        </small>
      </div>
    </div>

  </div>


  <!-- NÃO APLICADO -->

  <div
    class="coupon-input-row"
    *ngIf="!appliedCoupon">

    <input
      [(ngModel)]="couponCode"
      type="text"
      maxlength="30"
      placeholder="Digite seu cupom"
      [disabled]="couponLoading"
      (keyup.enter)="applyCoupon()">

    <button
      type="button"
      [disabled]="
        couponLoading ||
        !couponCode.trim()
      "
      (click)="applyCoupon()">

      {{
        couponLoading
          ? 'Aplicando...'
          : 'Aplicar'
      }}

    </button>

  </div>


  <!-- ERRO -->

  <div
    class="coupon-error"
    *ngIf="
      couponError &&
      !appliedCoupon
    ">

    <span>
      ⚠️
    </span>

    <span>
      {{ couponError }}
    </span>

  </div>


  <!-- CUPOM APLICADO -->

  <div
    class="applied-coupon"
    *ngIf="appliedCoupon">

    <div class="applied-coupon-info">

      <span class="applied-check">
        ✓
      </span>

      <div>

        <small>
          Cupom aplicado
        </small>

        <strong>
          {{ appliedCoupon.code }}
        </strong>

        <span
          *ngIf="
            appliedCoupon.name
          ">
          {{ appliedCoupon.name }}
        </span>

      </div>

    </div>


    <div class="applied-coupon-right">

      <strong>
        -{{ formatMoney(discountAmount) }}
      </strong>

      <button
        type="button"
        (click)="removeCoupon()">

        Remover

      </button>

    </div>

  </div>

</section>



        <div class="cart-form">
          <h4>Dados do pedido</h4>

          <label>Nome</label>
          <input
            [(ngModel)]="customer.customerName"
            placeholder="Seu nome"
            autocomplete="name">

          <label>Telefone</label>
          <input
            [(ngModel)]="customer.customerPhone"
            placeholder="WhatsApp"
            autocomplete="tel">

          <label>Tipo do pedido</label>
          <select
            [ngModel]="customer.deliveryType"
            (ngModelChange)="selectDeliveryType($event)">
            <option value="DELIVERY">Delivery</option>
            <option value="PICKUP">Retirada</option>
            <option value="TABLE">Mesa</option>
          </select>

          <ng-container *ngIf="customer.deliveryType === 'DELIVERY'">

            <label>CEP</label>
            <input
              type="text"
              inputmode="numeric"
              maxlength="9"
              [(ngModel)]="customer.customerZipCode"
              (input)="onZipCodeInput()"
              (blur)="calculateDeliveryFee()"
              placeholder="00000-000"
              autocomplete="postal-code">

            <div
              class="cart-delivery-status"
              *ngIf="
                restaurant.deliveryFeeType === 'ZIP_CODE' &&
                deliveryFeeCalculated &&
                deliveryAvailable === true
              ">
              ✓ Entrega disponível —
              {{
                calculatedDeliveryFee > 0
                  ? formatMoney(calculatedDeliveryFee)
                  : 'Grátis'
              }}
            </div>

            <div
              class="cart-delivery-error"
              *ngIf="
                restaurant.deliveryFeeType === 'ZIP_CODE' &&
                deliveryFeeError
              ">
              {{ deliveryFeeError }}
            </div>

            <label>Endereço</label>
            <input
              [(ngModel)]="customer.customerAddress"
              placeholder="Rua, número, complemento e bairro"
              autocomplete="street-address">

          </ng-container>

          <ng-container *ngIf="customer.deliveryType === 'TABLE'">
            <label>Mesa</label>
            <input
              [(ngModel)]="customer.tableNumber"
              placeholder="Número da mesa">
          </ng-container>

          <label>Observações</label>
          <textarea
            [(ngModel)]="customer.notes"
            placeholder="Ex: sem cebola">
          </textarea>
        </div>



<!-- RESUMO -->

<div class="cart-summary">

  <div class="summary-row">

    <span>
      Subtotal
    </span>

    <strong>
      {{ formatMoney(total()) }}
    </strong>

  </div>


  <div
    class="summary-row discount-row"
    *ngIf="
      discountAmount > 0
    ">

    <span>

      Desconto

      <small
        *ngIf="
          appliedCoupon?.code
        ">
        ({{ appliedCoupon.code }})
      </small>

    </span>

    <strong>
      -{{ formatMoney(discountAmount) }}
    </strong>

  </div>


  <div class="summary-row">

    <span>
      Entrega
    </span>

    <strong *ngIf="customer.deliveryType !== 'DELIVERY'">
      Sem taxa
    </strong>

    <strong
      *ngIf="
        customer.deliveryType === 'DELIVERY' &&
        restaurant.deliveryFeeType === 'FIXED'
      ">
      {{
        deliveryFeeAmount() > 0
          ? formatMoney(deliveryFeeAmount())
          : 'Grátis'
      }}
    </strong>

    <strong
      *ngIf="
        customer.deliveryType === 'DELIVERY' &&
        restaurant.deliveryFeeType === 'ZIP_CODE' &&
        !deliveryFeeCalculated &&
        deliveryAvailable !== false
      ">
      Calcule pelo CEP
    </strong>

    <strong
      *ngIf="
        customer.deliveryType === 'DELIVERY' &&
        restaurant.deliveryFeeType === 'ZIP_CODE' &&
        deliveryFeeCalculated &&
        deliveryAvailable === true
      ">
      {{
        deliveryFeeAmount() > 0
          ? formatMoney(deliveryFeeAmount())
          : 'Grátis'
      }}
    </strong>

    <strong
      class="summary-delivery-unavailable"
      *ngIf="
        customer.deliveryType === 'DELIVERY' &&
        restaurant.deliveryFeeType === 'ZIP_CODE' &&
        deliveryAvailable === false
      ">
      Indisponível
    </strong>

  </div>


  <div class="summary-divider"></div>


  <div class="summary-row total-row">

    <span>
      Total
    </span>

    <strong>
      {{ formatMoney(orderTotal()) }}
    </strong>

  </div>

</div>









        <div class="cart-footer">
          <div>
            <small>Total</small>
            <strong>{{ formatMoney(orderTotal()) }}</strong>
          </div>

          <!-- <button
            type="button"
            [disabled]="sending"
            (click)="finishOrder()">
            {{ sending ? 'Enviando...' : 'Continuar' }}
          </button> -->

<button
  type="button"
  [disabled]="
    sending ||
    !restaurantIsOpen
  "
  (click)="finishOrder()"
>
  {{
    !restaurantIsOpen
      ? 'Restaurante fechado'
      : sending
        ? 'Enviando...'
        : 'Continuar'
  }}
</button>



        </div>

      </div>
    </aside>

  </ng-container>
</main>